<template>
    <div class="assets-details-in-metadata-manager" v-on:scroll="loadMoreSubclips($event)">
      <div v-if="assetInfo == null || assetInfo == undefined" style="font-size: 20px; margin-top: 8%; color: #686868;text-align:center">
            No Data Found
          </div>
                <ul v-else>
                  <template v-if="assetInfo.asset_type && assetInfo.asset_type == 'catalog'">
                    <li v-if="Object.keys(assetInfo).includes('catalog_name') &&
                      !['undefined',null].includes(assetInfo.catalog_name) &&  assetInfo.catalog_name.length > 0">
                        <div class="key-style">{{$t('Catalog Name')}}</div>
                        <div class="value-style">{{assetInfo.catalog_name}}</div>
                    </li>
                    <li v-if="!['undefined',null].includes(categoryDetails) && categoryDetails.length > 0">
                        <div class="key-style">{{$t('Parent Catalog')}}</div>
                        <div class="value-style">
                          <template v-for="(op,index) of categoryDetails" >
                              <span :key="op._id">{{op.catalog_name}} {{getCatalogParentPath(op)}}</span>
                              <span :key="op._id" v-if="categoryDetails.length > 1 && categoryDetails.length != index + 1">, &nbsp;</span>
                          </template>
                        </div>
                    </li>
                  </template>
                    <li v-if="assetInfo.file_type == 'folder' && Object.keys(assetInfo).includes('dir_name') &&
                      !['undefined',null].includes(assetInfo.dir_name) &&  assetInfo.dir_name.length > 0">
                        <div class="key-style">{{$t('Folder Name')}}</div>
                        <div class="value-style">{{assetInfo.dir_name}}</div>
                    </li>
                    <li v-if="assetInfo.file_type == 'file' && Object.keys(assetInfo).includes('file_name') &&
                      !['undefined',null].includes(assetInfo.file_name) &&  assetInfo.file_name.length > 0">
                        <div class="key-style">{{$t('Filename')}}</div>
                        <div class="value-style">{{assetInfo.file_name}}</div>
                    </li>
                    <li v-if="Object.keys(assetInfo).includes('slug_name') &&
                      !['undefined',null].includes(assetInfo.slug_name) &&  assetInfo.slug_name.length > 0">
                        <div class="key-style">{{$t('Slug')}}</div>
                        <div class="value-style">{{assetInfo.slug_name}}</div>
                    </li>
                    <li v-if="Object.keys(assetInfo).includes('reference_id') &&
                      !['undefined',null].includes(assetInfo.reference_id) &&  assetInfo.reference_id.length > 0">
                        <div class="key-style">{{barcodeInfoFromStartup.alias &&  barcodeInfoFromStartup.alias.alias_name?barcodeInfoFromStartup.alias.alias_name:"Reference ID"}}</div>
                        <div class="value-style">{{assetInfo.reference_id}}</div>
                    </li>
                    <li v-if="barcodeInfoFromStartup.enable_department && Object.keys(assetInfo).includes('department_info') &&
                      !['undefined',null].includes(assetInfo.department_info) &&  assetInfo.department_info.name">
                        <div class="key-style">{{barcodeInfoFromStartup.department_alias &&  barcodeInfoFromStartup.department_alias.alias_name?barcodeInfoFromStartup.department_alias.alias_name:"Department"}}</div>
                        <div class="value-style">{{assetInfo.department_info.name}}</div>
                    </li>
                     <li v-if="Object.keys(assetInfo).includes('size') &&
                      !['undefined',null].includes(assetInfo.size) &&  assetInfo.size > 0">
                        <div class="key-style">{{$t('Size')}}</div>
                        <div class="value-style">{{humaniseSize(assetInfo.size)}} ({{assetInfo.size}} bytes)</div>
                    </li>
                    <li v-if="assetInfo && this.ttlToDelete">
                        <div class="key-style">{{$t('Expires on')}}</div>
                        <div v-if="this.ttlToDelete != parseFloat(-1)" class="value-style">{{getDateAndTimeInConfiguredFormat(this.ttlToDelete)}}</div>
                        <div v-else class="value-style">{{this.ttlToDelete}}
                        </div>
                    </li>
                    <li v-if="assetInfo && this.delPermttl">
                        <div class="key-style">{{$t('Permanently Expires on')}}</div>
                        <div v-if="this.delPermttl != parseFloat(-1)" class="value-style">{{getDateAndTimeInConfiguredFormat(this.delPermttl)}}</div>
                        <div v-else class="value-style">{{this.delPermttl}}
                        </div>
                    </li>
                    <li v-if="Object.keys(assetInfo).includes('created_datetime') &&
                      !['undefined',null].includes(assetInfo.created_datetime) &&  assetInfo.created_datetime.length > 0">
                        <div class="key-style">{{$t('Date Created')}}</div>
                        <div class="value-style">{{getDateAndTimeInConfiguredFormat(assetInfo.created_datetime)}}</div>
                    </li>
                    <li v-if="Object.keys(assetInfo).includes('added_datetime') &&
                      !['undefined',null].includes(assetInfo.added_datetime) &&  assetInfo.added_datetime.length > 0">
                        <div class="key-style">{{$t('Date Added')}}</div>
                        <div class="value-style">{{getDateAndTimeInConfiguredFormat(assetInfo.added_datetime)}}</div>
                    </li>
                    <li v-if="!Object.keys(assetInfo).includes('created_datetime') &&
                      Object.keys(assetInfo).includes('asset_created_datetime') &&
                      !['undefined',null].includes(assetInfo.asset_created_datetime) &&  assetInfo.asset_created_datetime.length > 0">
                        <div class="key-style">{{$t('Date Created')}}</div>
                        <div class="value-style">{{getDateAndTimeInConfiguredFormat(assetInfo.asset_created_datetime)}}</div>
                    </li>
                    <li v-if="!Object.keys(assetInfo).includes('added_datetime') &&
                      Object.keys(assetInfo).includes('asset_added_datetime') &&
                      !['undefined',null].includes(assetInfo.asset_added_datetime) &&  assetInfo.asset_added_datetime.length > 0">
                        <div class="key-style">{{$t('Date Added')}}</div>
                        <div class="value-style">{{getDateAndTimeInConfiguredFormat(assetInfo.asset_added_datetime)}}</div>
                    </li>
                    <li v-if="(assetInfo.asset_type && assetInfo.asset_type == 'catalog') ||
                              (assetInfo.file_type && assetInfo.file_type == 'folder')">
                      <div class="key-style">{{$t('Size')}}</div>
                      <div class="value-style">
                        <div v-if="catalogOrFolderSize && !['undefined',null].includes(catalogOrFolderSize)" style="margin-inline-end: 6px;">
                          {{humaniseSize(catalogOrFolderSize)}} ({{catalogOrFolderSize}} bytes)
                        </div>
                        <div v-else style="margin-inline-end: 6px;">NA</div>
                        <div v-if="jobId && jobId.length>0" style="color:#5d5d5d;margin-inline-start:0px;">
                          <img style="width:33px !important;height:24px !important;" :src="growingFileGif"/>
                          <span style="position: relative;top: 1px;">{{$t('Fetching')}}...</span>
                        </div>
                        <div class="border-0 folder_size" v-else  @click="calculateCatalogOrFolderSize()">
                          <span v-if="contentInfo && contentInfo.length > 0">Re-Calculate Size</span>
                          <span v-else>Calculate Size</span>
                        </div>
                      </div>
                    </li>
                    <li v-if="(assetInfo.asset_type && assetInfo.asset_type == 'catalog') ||
                              (assetInfo.file_type && assetInfo.file_type == 'folder')">
                      <div class="key-style">{{$t('Contents')}}</div>
                      <div class="value-style" style="text-transform: capitalize;">
                        <div v-if="contentInfo && contentInfo.length > 0" style="display: inline-flex;margin-inline-end:8px;">
                          <div v-for="(content, index) in contentInfo" style="display:flex" :key="content.type">
                            <div>{{content.count}}</div>
                            <div style="margin-inline-start: 2px;">{{$t(content.type)}}</div>
                            <div v-if="index < (contentInfo.length - 1)" style="margin-inline-end: 4px;margin-inline-start: 2px;">, </div>
                          </div>
                        </div>
                        <div v-else>NA</div>
                      </div>
                    </li>
                    <li v-if="assetInfo.storage_class && assetInfo.storage_class.length">
                          <div class="key-style">{{$t('Location')}}</div>
                          <div class="value-style">
                            <div v-for="storageClass in assetInfo.storage_class" class="d-inline-flex" :key="storageClass">
                              <svg v-if='storageClass == "Disk"' xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#35b2cf" class="bi bi-archive-fill" viewBox="0 0 16 16"><path d="M12.643 15C13.979 15 15 13.845 15 12.5V5H1v7.5C1 13.845 2.021 15 3.357 15h9.286zM5.5 7h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zM.8 1a.8.8 0 0 0-.8.8V3a.8.8 0 0 0 .8.8h14.4A.8.8 0 0 0 16 3V1.8a.8.8 0 0 0-.8-.8H.8z"></path><title>Archived</title></svg>
                              <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" :fill="getColorBasedOnExpiry(assetInfo.location_info,storageClass)" class="bi bi-cloud-fill storage-type-icon" viewBox="0 0 16 16">
                                <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                              </svg>
                              <span style="margin-inline-start:4px">{{ storageClass }}</span>
                            </div>
                          </div>
                      </li>
                    <li v-if="assetInfo.location_info && Object.keys(assetInfo.location_info).includes('alto') && assetInfo.location_info.alto.container_archive_path">
                        <div class="key-style">{{$t('Archive Path')}}</div>
                        <div class="value-style">
                          <div v-for="(archivePath,index) in assetInfo.location_info.alto.container_archive_path" :key="archivePath.container_id" :style="assetInfo.location_info.alto.container_archive_path.length>1?'margin-bottom:4px':''" class="dull-the-text" style="white-space: pre-wrap;">{{assetInfo.location_info.alto.container_archive_path.length>1?index+1+'.':''}} {{archivePath.archive_path}}{{index == assetInfo.location_info.alto.length -1?'':','}}&nbsp;&nbsp;</div>
                        </div>
                    </li>
                    <li v-if="assetInfo.location_info && Object.keys(assetInfo.location_info).includes('alto') && assetInfo.location_info.alto.container_archive_path">
                        <div class="key-style">{{$t('Container Name')}}</div>
                        <div class="value-style">
                            <template v-if="assetInfo.location_info && Object.keys(assetInfo.location_info).includes('alto')">
                              <span v-for="archivePath in assetInfo.location_info.alto.container_archive_path" class="change-the-text-color mr-1" :key="archivePath.container_id" style="white-space: pre-wrap;margin-bottom:5px;color: #46c5f5;border:1px solid #46b5f5;display:inline-flex;align-items:center;"><span
                                  style="width:10px;height:10px;border-radius:50%;margin-right:4px;display:inline-block;"
                                  :style="{
                                    backgroundColor:
                                     containerStatuses[archivePath.container_id] === true
                                      ? 'green'
                                      : containerStatuses[archivePath.container_id] === false
                                        ? 'red'
                                        : 'gray'
                                  }"
                                ></span>
                                {{archivePath.container_name}}
                              </span>
                            </template>
                        </div>
                    </li>
                    <!-- <li v-if="assetInfo.location_info && Object.keys(assetInfo.location_info).includes('archive_mediator') && assetInfo.location_info.archive_mediator.archive_container_info">
                      <div class="key-style">Archive Path</div>
                      <div class="value-style">
                        <div v-for="(archivePath,index) in assetInfo.location_info.archive_mediator.archive_container_info" :key="archivePath.container_id" :style="assetInfo.location_info.archive_mediator.archive_container_info.length>1?'margin-bottom:4px':''" class="dull-the-text" style="white-space: pre-wrap;">{{assetInfo.location_info.archive_mediator.archive_container_info.length>1?index+1+'.':''}}{{archivePath.archive_path}}{{index == assetInfo.location_info.archive_mediator.length -1?'':','}}&nbsp;&nbsp;</div>
                      </div>
                  </li> -->
                  <li v-if="assetInfo.location_info && Object.keys(assetInfo.location_info).includes('archive_mediator') && assetInfo.location_info.archive_mediator.archive_container_info">
                      <div class="key-style">{{$t('Container')}}</div>
                      <div class="value-style">
                          <template v-if="assetInfo.location_info && Object.keys(assetInfo.location_info).includes('archive_mediator')">
                            <template v-for="archivePath in assetInfo.location_info.archive_mediator.archive_container_info">
                              <span v-if="archivePath.container_id" :title="archivePath.instance_info.array_name" class="change-the-text-color mr-1" :key="archivePath.container_id" style="white-space: pre-wrap;margin-bottom:5px;color: #46c5f5;border:1px solid #46b5f5;">{{archivePath.container_id}}</span>
                            </template>
                          </template>
                      </div>
                  </li>
                    <li v-if="'mime_type' in assetInfo && assetInfo.mime_type && (assetInfo.mime_type.startsWith('video') || assetInfo.mime_type.startsWith('audio')) &&
                      'duration' in assetInfo && assetInfo.duration">
                        <div class="key-style">{{$t('Duration')}}</div>
                        <div class="value-style">{{getHumanReadableDuration(assetInfo.duration)}}</div>
                    </li>
                    <li v-if="'frame_rate' in assetInfo && assetInfo.frame_rate">
                        <div class="key-style">{{$t('Frame rate')}}</div>
                        <div class="value-style">{{assetInfo.frame_rate}}</div>
                    </li>
                    <li v-if="Object.keys(assetInfo).includes('asset_id') &&
                    !['undefined',null].includes(assetInfo.asset_id) &&  assetInfo.asset_id.length > 0">
                        <div class="key-style">{{$t('Asset Id')}}</div>
                        <div class="value-style">{{assetInfo.asset_id}}</div>
                    </li>
                    <li v-if="Object.keys(assetInfo).includes('user_id') &&
                    !['undefined',null].includes(assetInfo.user_id) &&  assetInfo.user_id.length > 0">
                      <div class="key-style">{{$t('User name')}}</div>
                      <div class="value-style">
                        <span class="mr-1 mb-1" >{{getDisplayDataOfUserUsingId(assetInfo.user_id).username }}</span>
                      </div>
                    </li>
                    <li v-if="assetInfo.file_type == 'file' && !['undefined',null].includes(categoryDetails) && categoryDetails.length > 0">
                        <div class="key-style">{{$t('Catalogs')}}</div>
                        <div class="value-style">
                          <template v-for="(op,index) of categoryDetails" >
                              <span :key="op._id">{{op.catalog_name}} [ {{op.parent_path.value.replace("catalog://0","")}} ]</span>
                              <span :key="op._id" v-if="categoryDetails.length > 1 && categoryDetails.length != index + 1">, &nbsp;</span>
                          </template>
                        </div>
                    </li>
                      <li>
                       <template v-if="Object.keys(assetInfo).includes('file_info') &&
                          !['undefined',null].includes(assetInfo.file_info) &&  assetInfo.file_info.length > 0">
                            <div class="key-style">{{$t('File Info')}}</div>
                            <div class="value-style">
                              <div v-for="file in assetInfo.file_info" :key="file" class="wrap-file-info" style="width:100%">
                                <template v-if="Object.keys(file).includes('file_path') && file.file_path.startsWith('share://CACHE') && 'location_info' in assetInfo && 'gravity_deep' in assetInfo.location_info">
                                  <div v-if="Object.keys(file).includes('file_name') &&
                                      !['undefined',null].includes(file.file_name) &&  file.file_name.length > 0" style="display:flex">
                                    <div class="key-style mr-2">{{$t('Archive ID')}}</div>
                                    <div class="value-style ml-0">{{file.file_name}}</div>
                                  </div>
                                  <div v-if="(Object.keys(file).includes('ttl') &&
                                      !['undefined',null].includes(file.ttl) &&  file.ttl.length > 0)"  style="display:flex">
                                    <div class="key-style mr-2">{{$t('Expires on')}}</div>
                                    <div class="value-style ml-0">{{getDateAndTimeInConfiguredFormat(file.ttl)}}</div>
                                  </div>
                                  <div v-if="(Object.keys(file).includes('ttk') &&
                                      !['undefined',null].includes(file.ttk) &&  file.ttk.length > 0)" style="display:flex">
                                    <div class="key-style mr-2">{{$t('Permanently Expires on')}}</div>
                                    <div class="value-style ml-0">{{getDateAndTimeInConfiguredFormat(file.ttk)}}</div>
                                  </div>
                                  <div v-if="file.location && file.location.length && assetInfo.location_info?.gravity_deep?.container_ids?.length > 0" style="display:flex">
                                      <div class="key-style mr-2">{{$t('Location')}}</div>
                                      <div class="value-style ml-0">{{assetInfo.location_info["gravity_deep"]["container_ids"].join(", ")}}</div>
                                  </div>
                                   <div style="display:flex;text-transform: capitalize;">
                                      <div class="key-style mr-2">{{$t('Locked')}}</div>
                                      <div class="value-style ml-0" v-if="'lock' in file && file.lock">{{file.lock}}</div>
                                      <div class="value-style ml-0" v-else>False</div>
                                  </div>
                                </template>
                                <template v-else>
                                  <div v-if="Object.keys(file).includes('file_name') &&
                                      !['undefined',null].includes(file.file_name) &&  file.file_name.length > 0" style="display:flex">
                                    <div class="key-style mr-2">{{$t('File Name')}}</div>
                                    <div class="value-style ml-0">{{file.file_name}}</div>
                                  </div>
                                  <div v-if="Object.keys(file).includes('file_path') &&
                                      !['undefined',null].includes(file.file_path) &&  file.file_path.length > 0" style="display:flex">
                                    <div class="key-style mr-2">{{$t('File Path')}}</div>
                                    <div class="value-style ml-0">{{file.file_path}}</div>
                                  </div>
                                  <div v-if="(Object.keys(file).includes('ttl') &&
                                      !['undefined',null].includes(file.ttl) &&  file.ttl.length > 0)"  style="display:flex">
                                    <div class="key-style mr-2">{{$t('Expires on')}}</div>
                                    <div class="value-style ml-0">{{getDateAndTimeInConfiguredFormat(file.ttl)}}</div>
                                  </div>
                                  <div v-if="(Object.keys(file).includes('ttk') &&
                                      !['undefined',null].includes(file.ttk) &&  file.ttk.length > 0)" style="display:flex">
                                    <div class="key-style mr-2">{{$t('Permanently Expires on')}}</div>
                                    <div class="value-style ml-0">{{getDateAndTimeInConfiguredFormat(file.ttk)}}</div>
                                  </div>
                                  <div v-if="(Object.keys(file).includes('tta') &&
                                      !['undefined',null].includes(file.tta) &&  file.tta.length > 0)" style="display:flex">
                                    <div class="key-style mr-2">{{$t('Archives on')}}</div>
                                    <div class="value-style ml-0">{{getDateAndTimeInConfiguredFormat(file.tta)}}</div>
                                  </div>
                                  <div v-if="file.location && file.location.length" style="display:flex">
                                      <div class="key-style mr-2">{{$t('Location')}}</div>
                                      <div class="value-style ml-0">
                                        <div v-for="storageClass in file.location" class="d-inline-flex" :key="storageClass">
                                          <svg v-if='storageClass == "Disk"' xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#35b2cf" class="bi bi-archive-fill" viewBox="0 0 16 16"><path d="M12.643 15C13.979 15 15 13.845 15 12.5V5H1v7.5C1 13.845 2.021 15 3.357 15h9.286zM5.5 7h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zM.8 1a.8.8 0 0 0-.8.8V3a.8.8 0 0 0 .8.8h14.4A.8.8 0 0 0 16 3V1.8a.8.8 0 0 0-.8-.8H.8z"></path><title>Archived</title></svg>
                                          <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" :fill="getColorBasedOnExpiry(assetInfo.location_info,storageClass)" class="bi bi-cloud-fill storage-type-icon" viewBox="0 0 16 16">
                                            <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                                          </svg>
                                          <span style="margin-inline-start:4px">{{ storageClass }}</span>
                                        </div>
                                      </div>
                                  </div>
                                  <div style="display:flex;text-transform: capitalize;">
                                    <div class="key-style mr-2">{{$t('Locked')}}</div>
                                    <div class="value-style ml-0" v-if="'lock' in file && file.lock">{{file.lock}}</div>
                                    <div class="value-style ml-0" v-else>False</div>
                                </div>
                                </template>
                                <div v-if="isEnabled('Lock/Unlock') && file.state && ['READY'].includes(file.state)" class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" style="position:absolute;top:10px;inset-inline-end:5px;cursor: pointer">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#9c9c9c" class="bi bi-three-dots-vertical hightlight-icon" viewBox="0 0 16 16">
                                        <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                                      </svg>
                                      <div class="dropdown-menu dropdown-menu-md-right p-0" aria-labelledby="bd-versions" style="inset-inline-start:0px;">
                                        <a v-if='"lock" in file && file.lock' v-on:click="handleFileLockOrUnlockState(file)" class="dropdown-item p-2">{{$t('Unlock')}}</a>
                                        <a v-else v-on:click="handleFileLockOrUnlockState(file, true)" class="dropdown-item p-2 delete-version">{{$t('Lock')}}</a>
                                      </div>
                                    </div>
                              </div>
                            </div>
                        </template>
                        <template v-else-if="Object.keys(assetInfo).includes('path') &&
                          !['undefined',null].includes(assetInfo.path) &&  assetInfo.path.length > 0">
                            <div class="key-style">{{$t('Path')}}</div>
                            <div class="value-style">{{assetInfo.path}}</div>
                        </template>
                    </li>
                    <li v-if="labelInfo && labelInfo.length">
                      <div class="key-style">{{$t('Labels')}}</div>
                      <div class="value-style">
                        <span v-for="label in labelInfo" :key="label.label_id" class="display-label mr-1 mb-1" :style="label.label_type == 'user_defined'?applyBorder(label):applyBackground(label)">{{label.name}}</span>
                      </div>
                    </li>
                    <!-- <li>
                        <div class="key-style">Custom Metadata</div>
                        <div class="value-style">
                          <ul>
                            <li v-for="cm in selectedAsset.custom_metadata" :key="cm.key_id">{{getCustomMetadataValue(cm.key_id)}}</li>
                            </ul></div>
                    </li> -->
                    <li v-show="getTagIds.length">
                        <div class="key-style">{{$t('Tags')}}</div>
                        <div class="value-style"><ul class="tags-display-ul p-0 ml-0">
                    <li
                      v-for="tagId in getTagIds"
                      :key="tagId"
                      style="padding-inline-start: 0px !important"
                      class="view-tags">
                      <span>{{ getTagNamefromId(tagId) }}</span>
                    </li>
                  </ul></div>
                    </li>
                    <li v-if="!['undefined',null].includes(getDescription()) && getDescription()">
                        <div class="key-style">{{$t('Description')}}</div>
                        <div class="value-style">{{getDescription()}}</div>
                    </li>
                    <li v-for="custommetadata in assetCustomMetadata"
                    :key="custommetadata.key_id" class="d-block p-0"
                    >
                      <ul  class="m-0">
                        <li class="p-2 custom-metadata-rows">
                            <div class="key-style">{{ getCustomMetadataName(custommetadata.key_id) }}</div>
                            <div class="value-style d-inline-flex">
                              <template v-if="['PICKLIST','PICKLIST_MULTIVALUE'].includes(custommetadata.type)">
                                <div class="w-100" v-if="custommetadata.value.length">
                                  {{getPicklistValueNames(custommetadata.value)}}
                                </div>
                              </template>
                              <template v-else>
                                <div class="w-100" v-if="custommetadata.value.length">
                                  {{custommetadata.value.join(",")}}
                                </div>
                              </template>
                            </div>
                          </li>
                      </ul>
                  </li>
                 <li v-show="subclipsList.length && assetInfo.file_type != 'folder'" class="subclips-section" style="flex-direction: column;">
                    <div
                          class="text-left"
                          style="margin-inline-start: -11px; color: #777"
                      >
                        <svg  v-if="!showSubClipsInfo" v-on:click="showSubClipsInfo = true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill icon-background-on-hover" viewBox="0 0 16 16">
                            <path stroke="currentColor" stroke-width="1" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
                        </svg>
                        <svg v-if="showSubClipsInfo" v-on:click="showSubClipsInfo = false" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill icon-background-on-hover" viewBox="0 0 16 16">
                            <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                        </svg>
                        <span style="position:relative;inset-inline-start:1px;top:2px;font-size: 18px;">{{$t('Sub Clips')}}</span>
                    </div>

                    <ul v-show="showSubClipsInfo">
                      <!-- <div style="text-align: start;font-size: 15px;">Sub Clips</div> -->
                      <li v-for="subclip in subclipsList" :key="subclip._id" class="display-subclips" style="padding:0px;cursor:pointer;" :class="{'active-subclip-preview': subclip._id === activeSubclipPreview}" @click="previewSubclipMarkinMarkout(subclip)">
                        <subclip-rows :subclipsData="subclip" :fileInfo="fileInfo" :isProperitesWindow="true" :customStyles="subclipsRowsStyles" @previewProxy="previewProxy" @loadVideo="playTranscript" :disableTranscriptEditMode="true"></subclip-rows>
                      </li>
                    </ul>
                  </li>
                  <li v-show="assetInfo.link_info && assetInfo.link_info.length > 0">
                    <div style="display:inline-block;width:100%">
                      <div class="text-left"  style="margin-inline-start: -11px; color: #777">
                        <svg v-if="!showAssetsLinkInfo" v-on:click="showAssetsLinkInfo = true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill icon-background-on-hover" viewBox="0 0 16 16">
                          <path stroke="currentColor" stroke-width="1" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
                        </svg>
                        <svg v-if="showAssetsLinkInfo" v-on:click="showAssetsLinkInfo = false" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill icon-background-on-hover" viewBox="0 0 16 16">
                          <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                        </svg>
                        <span style="position:relative;inset-inline-start:1px;top:2px;font-size: 18px;">Linked Assets</span>
                      </div>
                      <table v-if="showAssetsLinkInfo" class="tabletable-with-border table-scroll small-first-col table-cell-styles" style="background: transparent; width: 100%;padding-inline-end:0px !important;margin-top: 20px;">
                        <tbody class="body-half-screen">
                            <template v-for="op in selectedLinkList">
                                <tr :key="op._id" class="comm-table-row">
                                    <td class="text-left" style="width: 22%;vertical-align: top;">
                                        <div style="display: inline-block;width: 100%;text-align: end;">
                                            <span  style="margin-top: 20px;width:100%;display:inline-block">{{labelOflinksList[op.uuid].inward_desc}}</span>
                                        </div>
                                    </td>
                                    <td class="text-center" style="vertical-align: top;width:72%">
                                        <div class="comm-screen-profile-fields" style="display:flex;width:100%;display:inline-flex;">                                                       
                                            <ul class="thumbnail-view-ul folder-view-ul" style="width:84%;display:inline-block;padding-inline-start:5px">
                                                <li
                                                    class="folder-view-li"
                                                    v-for="asstInfo1 in op.linked_asset_info" :key="asstInfo1._id"
                                                    :class="{ 'reduce-opacity': asstInfo1.state == 'MARK FOR DELETE'}"
                                                    :title="asstInfo1.slug_name">
                                                    <div class="folder-view" :class="asstInfo1.asset_state == 'MARK FOR DELETE'?'reduce-opacity':' '" @click="loadPreview(asstInfo1)">
                                                        <div class="card" style="width: 34px; height: 78%; top:6px; overflow: hidden; display: flex; background-color: transparent;border-radius: 7px;">
                                                            <img class="card-img-top" :src="getThumbnailPath(asstInfo1)" @error="(e) => replaceByDefaultImage(e,asstInfo1)" alt="Card image cap" style="height: 100%;max-width: inherit;max-height: inherit;width: inherit;object-fit: cover;background-color: transparent">
                                                        </div>
                                                        <img v-if="asstInfo1.state == 'GROWING'" :src="growingFileGif" alt="markfordelete" style="height: 20px;width: 20px;position: relative;bottom: 86%;">
                                                        <img v-if="asstInfo1.state == 'MARK FOR DELETE'" :src="markForDeleteIcn" alt="markfordelete" style="height: 20px;width: 20px;position: relative;bottom: 86%;">
                                                    </div>
                                                    <div class="catalogs-data">
                                                        <div v-html="getSvgIconsOfMediaTypes(asstInfo1)" class="svg-icons-display" style="display:inline-table"></div>
                                                        {{ asstInfo1.slug_name }}
                                                    </div>
                                                    <div style="display:inline-flex;justify-content:center;position: absolute;inset-inline-end :10px;cursor:pointer" @click="openAssetInCatalog(asstInfo1)">
                                                      <template v-if="(!('state' in asstInfo1) || ('state' in asstInfo1 && !['MARK FOR DELETE'].includes(asstInfo1.state)))">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3adad" class="bi bi-folder-fill icons-wrapper" viewBox="0 0 16 16">
                                                          <title>{{$t('Open in Catalog')}}</title>
                                                          <path d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.826a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z"/>
                                                        </svg>
                                                      </template>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                      </table>
                    </div>
                  </li>
                  <!-- <li style="flex-direction: column;" v-if="isPluginInstalled('Transcript') && assetDetails && assetDetails.ai_info && assetDetails.ai_info.transcript && assetDetails.ai_info.transcript.length">
                     <div
                          class="text-left"
                          style="margin-inline-start: -11px; color: #777"
                      >
                        <svg  v-if="!showTranscript" v-on:click="showTranscript = true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill icon-background-on-hover" viewBox="0 0 16 16">
                            <path stroke="currentColor" stroke-width="1" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
                        </svg>
                        <svg v-if="showTranscript" v-on:click="showTranscript = false" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill icon-background-on-hover" viewBox="0 0 16 16">
                            <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                        </svg>
                        <span style="position:relative;inset-inline-start:1px;top:2px;font-size: 18px;">{{$t('Transcript')}}</span>
                      </div>
                    <ul class="transcript-section" v-if="showTranscript">
                      <li v-for="transcript in assetDetails.ai_info.transcript" :key="transcript.uid" style="color: #c7c7c7;padding:7px 0px" class="transcript-list">
                        <div class="transcript-play"> 
                          <div class="transcript-and-timescode">
                              <div style="display: flex;" class="transcript-play-pause" @click="$emit('playTranscript',transcript)">
                                <svg  xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="#dbdbdb" viewBox="0 0 16 16" class="bi bi-play-fill"><path  d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"></path></svg>
                              </div>
                              <div class="common-media-in-out-display">
                                <span>{{getDurationFormatAsHHorMMSS(transcript.media_in)}}</span> - <span>{{getDurationFormatAsHHorMMSS(transcript.media_out)}}</span>
                              </div>
                          </div>
                          <div>
                              {{transcript.content}}
                           </div> 
                        </div>
                      </li>
                    </ul>
                  </li> -->

                 <!-- commented for external plugin -->
                 
                 <template v-for="list in getPropertiesMetadataPlugins" >
                    <component  v-if="evaluatePluginCondition(list)" :key="list.id" :is="list.component" v-bind="{assetDetails:assetDetails,getDurationFormatAsHHorMMSS:getDurationFormatAsHHorMMSS,from:'basicProperties'}"></component>
                 </template> 


                  <!-- <li style="flex-direction: column;" v-if="isPluginInstalled('Face detection') && assetDetails && assetDetails.ai_info && assetDetails.ai_info.face_detection && assetDetails.ai_info.face_detection.length">
                    <div
                        class="text-left"
                        style="margin-inline-start: -11px; color: #777"
                    >
                      <svg  v-if="!showFaceDetection" v-on:click="showFaceDetection = true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill icon-background-on-hover" viewBox="0 0 16 16">
                          <path stroke="currentColor" stroke-width="1" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
                      </svg>
                      <svg v-if="showFaceDetection" v-on:click="showFaceDetection = false" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill icon-background-on-hover" viewBox="0 0 16 16">
                          <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                      </svg>
                      <span style="position:relative;inset-inline-start:1px;top:2px;font-size: 18px;">{{$t('Faces')}}</span>
                    </div>
                    <ul class="transcript-section" v-if="showFaceDetection">
                      <template v-if="getMimeType == 'video' || getMimeType == 'audio'">
                        <li v-for="faceObjs in confirmedFaceObjects" :key="faceObjs[0].uuid" style="color: #c7c7c7;" class="transcript-list">
                          <div class="transcript-play" v-if="faceObjs[0].media_in > -1"> 
                            <div class="transcript-and-timescode">
                                <div style="display: flex;" class="transcript-play-pause" @click="$emit('playTranscript',faceObjs[0])">
                                  <svg  xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="#d7d5d5" viewBox="0 0 16 16" class="bi bi-play-fill"><path  d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"></path></svg>
                                </div>
                                <div class="common-media-in-out-display">
                                  <span>{{getDurationFormatAsHHorMMSS(faceObjs[0].media_in)}}</span> - <span>{{getDurationFormatAsHHorMMSS(faceObjs[0].media_out)}}</span>
                                </div>
                            </div>
                            <div v-for="faceObj in faceObjs" :key="faceObj.uuid" style="display:inline-flex">
                              <div v-if="checkProfileImageExist(faceObj.object_id)" class='user-name-or-image' >
                                <img :src="checkProfileImageExist(faceObj.object_id)" @error="replaceWithUserIcon($event,faceObj.name)" style="width:100%;height:100%;border-radius:6px;margin-bottom: 5px">
                              </div>
                              <div v-else class="user-name-or-image" :title="faceObj.name" :style="style(faceObj.name)">{{faceObj.name.split("")[0]}}</div>
                              <div style="margin-top: 6px;margin-inline-start: 4px;">
                                  {{faceObj.name}}
                              </div> 
                            </div>
                          </div>
                        </li>
                      </template>
                      <template v-else-if="getMimeType == 'image'">
                        <li style="color: #c7c7c7;" class="transcript-list">
                            <FaceDetectionPersonalities :isSearchHighlightRequired="false" :assetDetailsFromParent="assetDetails" :imageWidth="160" :faceDetectionList="assetDetails.ai_info.face_detection"></FaceDetectionPersonalities>
                        </li>
                      </template>
                    </ul>
                  </li> -->

                 <!-- <li style="flex-direction: column;" v-if="isPluginInstalled('OBD') && assetDetails && assetDetails.ai_info && assetDetails.ai_info.obd && assetDetails.ai_info.obd.length > 0">
                    <div class="text-left" style="margin-inline-start: -11px; color: #777">
                      <svg  v-if="!showObdDetection" v-on:click="showObdDetection = true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill icon-background-on-hover" viewBox="0 0 16 16">
                          <path stroke="currentColor" stroke-width="1" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
                      </svg>
                      <svg v-if="showObdDetection" v-on:click="showObdDetection = false" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill icon-background-on-hover" viewBox="0 0 16 16">
                          <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                      </svg>
                      <span style="position:relative;inset-inline-start:1px;top:2px;font-size: 18px;">{{$t('Objects')}}</span>
                    </div>
                    <div v-if="showObdDetection" class="value-style d-inline-flex" style="border: 0px solid #4a4a4a;border-radius: 4px;padding: 6px !important;margin: 0px !important;width: 100%;display: inline-block !important;">
                        <div class="w-100">
                          <ul class="tags-display-ul p-0" style="display:inline-block;width: 100%;">
                              <div v-for="obj in assetDetails.ai_info.obd" :key="obj.object_id" style="float: inline-start;">
                                <li v-if="obj.status == 'confirmed'"
                                    :key="obj.object_id"
                                    class="view-tags">
                                    <span>{{obj.name}}</span>
                                </li>
                              </div>
                          </ul>
                        </div>  
                    </div>
                  </li>  -->

                  <!-- <li style="flex-direction: column;" v-if="isPluginInstalled('OCR') && assetDetails && assetDetails.ai_info && assetDetails.ai_info.ocr && assetDetails.ai_info.ocr[0].script.replace('\n','').trim().length > 0">
                    <div class="text-left" style="margin-inline-start: -11px; color: #777">
                      <svg  v-if="!showOcrDetection" v-on:click="showOcrDetection = true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill icon-background-on-hover" viewBox="0 0 16 16">
                          <path stroke="currentColor" stroke-width="1" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
                      </svg>
                      <svg v-if="showOcrDetection" v-on:click="showOcrDetection = false" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill icon-background-on-hover" viewBox="0 0 16 16">
                          <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                      </svg>
                      <span style="position:relative;inset-inline-start:1px;top:2px;font-size: 18px;">{{$t('OCR')}}</span>
                    </div>
                    <div v-if="showOcrDetection"
                      ref="ocr" style="padding: 10px;text-align: start;border: 0px solid #4a4a4a;border-radius: 4px;color: #eee;">
                      {{ assetDetails.ai_info.ocr[0].script }}
                  </div>
                  </li> -->

                  <li style="flex-direction: column;" v-if="isEnabled('manage-asset-annotaion') && getMimeType == 'image' && isAnnotationCommentsPresent()">
                    <div class="text-left" style="margin-inline-start: -11px; color: #777;display: flex; align-items: center;">
                      <svg  v-if="!showAnnotationComments" v-on:click="showAnnotationComments = true;isAnnotationCommentsStartedLoading = true;getAnnotationComments();" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill icon-background-on-hover" viewBox="0 0 16 16">
                          <path stroke="currentColor" stroke-width="1" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
                      </svg>
                      <svg v-if="showAnnotationComments && isAnnotationCommentsLoaded" v-on:click="showAnnotationComments = false" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill icon-background-on-hover" viewBox="0 0 16 16">
                          <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                      </svg>
                      <div v-if="showAnnotationComments && isAnnotationCommentsStartedLoading && !isAnnotationCommentsLoaded" class="annotation-loading" style="display: flex; align-items: center; gap: 0px; position: relative; inset-inline-start :-13px; top: 2px;">
                        <div>
                           <img style="width:53px;height:34px;" :src="growingFileGif"/>
                        </div>
                        <div style="margin-inline-start: -5px;">
                          {{$t('Loading Annotation comments')}}...
                        </div>
                      </div>
                      <!-- <img v-if="showAnnotationComments" :src="growingFileGif" style="width:16px;height:16px"/> -->
                      <span v-else style="font-size: 18px;">{{$t('Annotations')}}</span>
                    </div>
                    <div v-if="showAnnotationComments && Object.keys(annotationComments).length && annotationComments.asset_comments.length"
                      style="padding: 10px;text-align: start;border: 1px solid #4a4a4a;border-radius: 4px;color: #eee;">
                        <CommentsThread  v-for="comment in annotationComments.asset_comments" :enableReplyEditDeleteActionRequired="false" :key="comment.asset_id" :commentData="comment" :repliedCommentslist="[]" :reviewInfo="{}" @openPictureInPicture="handleShowAnnotationPreview" style="cursor: default;"></CommentsThread>
                        <button v-if="annotationComments && annotationComments.page_count > annotationComments.page" class="btn btn-outline-secondary btn-lg btn-block m-2" style="border: 1px solid rgb(88, 88, 88);position: relative;transform:translateX(-50%);inset-inline-start:50%;width: 80%;font-size: 1rem;" @click="getAnnotationComments(true)">Load More</button>
                     </div>
                     <div v-if="(!annotationComments || (annotationComments && annotationComments.asset_comments && !annotationComments.asset_comments.length)) && showAnnotationComments" style="padding: 10px;text-align: start;border: 1px solid #4a4a4a;border-radius: 4px;color: rgb(147, 146, 146);">
                           {{$t('No comments yet')}}.
                     </div>
                  </li>

             </ul>
            <ImagePreviewDialog @closeMiniPlayer="isAnnotationPriviewShown = false" @hook:mounted="picPicZindex(9999, 'fullscreen-pic')" :selectedFile="annotationPreviewData" class="hide-element-util-mount" v-cloak v-if="isAnnotationPriviewShown"></ImagePreviewDialog>
      </div>
</template>


<script>
import Utils from "../../components.utils.js" ;
import {mapActions, mapGetters, mapMutations } from "vuex";
import {NotifierConstants} from "../../components.constants.js";
import SubclipRows from "../subclips/SubclipsRows.vue";
import FaceDetectionPersonalities from '../FusionAI/DetectedPersonalities.vue';
import CommentsThread from "../core/CommentsThread.vue";
import ImagePreviewDialog from "../core/ImagePreviewDialog.vue";

export default {
    props:["fileInfo", "context"],
    data(){
        return{
        fieldInfo:[],
        customMetadataList: [],
        categoryName:"",
        categoryId:"",
        assetInfo:null,
        isLoaded:false,
        assetId:null,
        time:null,
        ttlToDelete:null,
        delPermttl:null,
        isTagsBrowse:false,
        isCategoryBrowse: false,
        assetDetails:{},
        picklistValue:{},
        description: "",
        slugName: "",
        getTagIds:[],
        assetCustomMetadata :[],
        categoryDetails:[],
        page:1,
        totalSubclipsPages:-1,
        subclipsList:[],
        subclipsRowsStyles:{
          slugFontSize:{"font-size":"15px"},
          duration:{"font-size":"14px"},
          image:{"width":"150px"}
        },
        svgIconForStorageClass:{"Amazon S3 Glacier":'<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-cloud-fill" viewBox="0 0 16 16"><path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/></svg>',
                                    "Amazon S3 Glacier Instant Retrieval":'<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#28a745" class="bi bi-cloud-fill" viewBox="0 0 16 16"><path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/></svg>',
                                    "Amazon S3 Standard":'<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#28a745" class="bi bi-cloud-fill" viewBox="0 0 16 16"><path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/></svg>',
                                    "Disk":'<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#35b2cf" class="bi bi-archive-fill" viewBox="0 0 16 16"><path d="M12.643 15C13.979 15 15 13.845 15 12.5V5H1v7.5C1 13.845 2.021 15 3.357 15h9.286zM5.5 7h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zM.8 1a.8.8 0 0 0-.8.8V3a.8.8 0 0 0 .8.8h14.4A.8.8 0 0 0 16 3V1.8a.8.8 0 0 0-.8-.8H.8z"></path><title>Archived</title></svg>' },
        activeSubclipPreview:"",
        showFaceDetection: true,
        showObdDetection:true,
        showOcrDetection: true,
        showTranscript: true,
        showSubClipsInfo: true,
        showAssetsLinkInfo: true,
        showAnnotationComments: false,
        isAnnotationCommentsLoaded: false,
        linksList:[],
        selectedLinkList:[],
        labelOflinksList:{},
        annotationComments:{},
        isAnnotationPriviewShown: false,
        annotationPreviewData:null,
        isAnnotationCommentsStartedLoading:false,
        growingFileGif: Utils.getLoadingGif(),
        markForDeleteIcn: Utils.getMarkForDeleteIcon(),
        isJobFailed:false,
        jobId:"",
        catalogOrFolderSize:0,
        contentInfo:[],
        labelInfo:[],
        containerStatuses: {},
      }
    },
    components:{
      "subclip-rows":SubclipRows,
      FaceDetectionPersonalities,
      CommentsThread,
      ImagePreviewDialog
    },
    computed:{
        getMimeType(){
          try{
            return Utils.getFileMediaType(this.assetDetails);
          }catch(e){
              console.log(e);
          }
          return '';
      },
      barcodeInfoFromStartup:{
        get(){
            return this.$store.state.startUpData.startUpDataDetails;
        }
      },
      confirmedFaceObjects(){
        let objects = []
        let a = this.assetDetails.ai_info.face_detection
        a =a.concat(a)
        a.forEach(obj => {
          let matchingGroup = objects.find(group => group.every(item=>item.mark_in === obj.mark_in &&
                                                                                  item.media_out === obj.media_out &&
                                                                                  item.status === "confirmed" &&
                                                                                  item.name && item.name.trim().length > 0));
          if(obj.status === "confirmed"){
            if (matchingGroup) {
              matchingGroup.push(obj);
            } else {
              objects.push([obj]);
            }
          }
        });
        return objects;
      },
      ...mapGetters('pluginRepo',["getInstalledPluginsData"]),
      ...mapGetters("users",["getLoggedInUserPrivilege", "getLoggedInUserId","getUsersBasicInfoFromStore"]),
      ...mapGetters("registry",["getPropertiesMetadataPlugins"]),
    },

    watch: {
      'assetInfo.location_info.alto.container_archive_path': {
        handler(containerPaths) {
          if (Array.isArray(containerPaths) && containerPaths.length > 0) {
            this.getContainerStatus();
          }
        },
        immediate: true
      }
    },

    methods:{

    playTranscript(transcript){
        this.$emit("playTranscript", transcript)
    },
         evaluatePluginCondition(list){
            return list.evalCondition(this);
         },
        isAnnotationCommentsPresent(){
            if(this.assetDetails && Object.prototype.hasOwnProperty.call(this.assetDetails,'annotation_present')){ // if key present then return it's value
                return this.assetDetails.annotation_present;
            }
            //if key does not present then as a backward compatibility show annotation button
            return true;
        },
        handleShowAnnotationPreview(comment){
          let slugName = '', commentData = {};
          if(this.fileInfo.slug_name){
              slugName = this.fileInfo.slug_name;
          }else{
              slugName = this.fileInfo.file_name;
          }
          Object.assign(commentData,{file_name:slugName,mime_type:'image/png',proxy_info:{"thumbnail_uri":comment.annotaion_thumbnail_url}});

          this.annotationPreviewData = commentData;
          this.$nextTick(()=>{
              this.isAnnotationPriviewShown = true;
          });
      },
      handleFileLockOrUnlockState(fileInfo, lockState=false){
        let payload = {file_uid:[fileInfo.file_uid],element_type: "assets",job_name: "Lock/Unlock",asset_lock: lockState}
        this.createNewJob(payload).then((data) => {
          if (data.statusCode == 200) {
            this.$toast.success("Job submitted successfully");
          } else {
            this.$toast.error(data.message);
          }
        });
      },
      isEnabled(priv) {
          return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege, priv);
      },
      getAnnotationComments(isLoadmore = false){
          let payload = {params:{asset_id:this.fileInfo.asset_id,comment_type:'annotate',version_id:this.fileInfo.version_id}};
          if(isLoadmore){
              payload.params['page'] = this.annotationComments.page + 1;
          }
          this.getAssetsAnnotationWithComments(payload).then(data =>{
              if(!Utils.isAcceptedStatusCode(data.statusCode)) {
                    this.$toast.error(data.message);
                    this.isAnnotationCommentsLoaded = true;
                    this.isAnnotationCommentsStartedLoading = false;
                    return;
              }
             if(!isLoadmore){
                this.annotationComments = data;
             }else{
                let tempData = data;
                tempData.asset_comments = this.annotationComments.asset_comments.concat(tempData.asset_comments);
                Object.assign(this.annotationComments,tempData);
             }
             this.isAnnotationCommentsLoaded = true;  
             this.isAnnotationCommentsStartedLoading = false;
          });

      },
      openAssetInCatalog(assetInfo){
        let fileInfo = assetInfo;
        fileInfo['asset_id'] = assetInfo._id
        this.$emit("openInCatalog", fileInfo)
      },
      getSvgIconsOfMediaTypes(path,type){
        return Utils.determineSvgIconForType(path,type)
      },
      loadPreview(assetInfo){
          this.$emit('previewLinkedAsset',assetInfo);
      },
      applyBorder(label){
        return {'border':'2px solid'+label.color+'!important','color':label.color}
      },
      applyBackground(label){
        return {'background':label.color+'!important','color':Utils.textColor(label.color)}
      },
      previewProxy(fileInfo){
        this.$emit("previewVersions",fileInfo)
      },
      isPluginInstalled(pluginName){
        if(this.getInstalledPluginsData){
            let indx = this.getInstalledPluginsData.findIndex(e => e.plugin_name.toLowerCase() == pluginName.toLowerCase())
            if(indx > -1){
                return true;
            }
        }
        return false;
      },
      style(name){
          let style = {
              'color':Utils.textColor(Utils.intToRGB(Utils.hashCode(name))),
              'background-color':'#'+Utils.intToRGB(Utils.hashCode(name))
          }
          return style
      },

      checkProfileImageExist(profileObjId){
        let profileImage = "";
        if('personality_info' in this.assetDetails && this.assetDetails.personality_info.length>0){
            let personalityInfo = this.assetDetails.personality_info;
            let personalityObjIndex = personalityInfo.findIndex((obj)=>obj._id == profileObjId);
            if (personalityObjIndex>=0){
              if('profile_image' in personalityInfo[personalityObjIndex] && personalityInfo[personalityObjIndex].profile_image){
                profileImage = personalityInfo[personalityObjIndex].profile_image;
              }
            }
        }
        return profileImage;
      },
      getColorBasedOnExpiry(locationInfo,storage){
        return Utils.getAWSStorageIconColorBasedOnExpiry(locationInfo,storage)
      },

      replaceByDefaultImage(e,fileInfo){
                e.target.onerror = null
                if(fileInfo && fileInfo.mime_type && fileInfo.mime_type.startsWith('audio')){
                    e.target.src = Utils.getAudioWaveformSvg();
                    return;
                }
                e.target.src = Utils.getNoThumbnailImg();
            },
      getThumbnailPath(file){
          return Utils.getThumbnailPathfromFileInfo(file)
      },
      getDurationFormatAsHHorMMSS(duration){
        return Utils.getDurationInHHorMMSS(duration / 1000);
      },
      getSvgIconForStorageClass(type){
        return this.svgIconForStorageClass[type];
      },
      getHumanReadableDuration(duration){
        // return Utils.getDurationInSeconds(duration, true) //since value should show in hh:mm:ss  (00:00:25) so removed 'true' in parameter
        return Utils.getDurationInSeconds(duration);
      },
      previewSubclipMarkinMarkout(subclip){
     /*    let markin = subclip.markers.start;
        let markout = subclip.markers.end;
        if(markin && isNaN(Number(markin))) markin = Utils.hhmmssToMs(markin);
        if(markout && isNaN(Number(markout))) markout = Utils.hhmmssToMs(markout); */
        this.activeSubclipPreview = String(subclip._id);
          if(this.$parent && this.$parent.$parent && this.$parent.$parent.$parent) this.$parent.$parent.$parent.$emit('playSubclipMarkinMarkout',subclip);
      },
      getPicklistValueNames(multiValueIds){
        if(multiValueIds != undefined && multiValueIds.length > 0){
          let valList =[];
          for(let valId of multiValueIds){
            let valDetails = this.fieldInfo.filter(op=>op.value_id == valId);
            if(valDetails.length > 0){
              valList.push(valDetails[0].value);
            }
          }
          return valList.join(", ");
        }
        return "None"
      },
      formatedDate(date){
        return Utils.getDateTimeFormat(date);
      },
      getCatalogParentPath(op){
        let path = op.parent_path.value.replace("catalog://0","")
        if(path){
          return `[ ${path} ]`;
        }
        return "[/]"
      },
      humaniseSize(bytes){
            let data = Utils.humanizeSize(bytes)
            return `${data["value"]} ${data["unit"]}`
        },
      getDescription(){
        if ("metadata" in this.assetDetails){
          return this.assetDetails.metadata.description
        }
        return ""
    },
    getCustomMetadataMapperName(fieldInfo){
      if('language_alias_mapper' in fieldInfo && fieldInfo.language_alias_mapper && fieldInfo.language_alias_mapper.length > 0 && this.$i18n && this.$i18n.locale){
        let mapperExists = fieldInfo.language_alias_mapper.find(op=>op.code == this.$i18n.locale)
        if(mapperExists && Object.keys(mapperExists).length > 0 && mapperExists.field_alias && mapperExists.field_alias.length > 0){
          return mapperExists.field_alias;
        }
      }
      return fieldInfo.name;
    },
    getCustomMetadataName(id){
      let customMetadataDetails = this.customMetadataList.filter(c=>c._id == id);
      if(customMetadataDetails.length > 0){
        return this.getCustomMetadataMapperName(customMetadataDetails[0]);
      }
      return "";
    },
    getCustomMetadataValueById(id, multiValues=false){
      if(this.assetCustomMetadata.length != 0){
        let cmdata = this.assetCustomMetadata.filter((cdata)=>cdata.key_id == id)[0];
        if(cmdata != undefined){
          if(cmdata.value.length > 1){
            return cmdata.value;
          }else if(multiValues){
            return cmdata.value;
          }else if(["DATE_TIME"].includes(cmdata.type)){
            let cVal = cmdata.value[0];
            cVal = cVal.replace("T", " ");
            return cVal;
          }else{
            return cmdata.value[0];
          }
        }
      }
      return ""
    },
        getTagNamefromId(tagId){
          let tagName = "";
          let tagInfo = this.tagIdNameMapper.filter(t=>t.tag_id==tagId);
          if (typeof tagInfo != "undefined" && tagInfo.length > 0){
              tagName = tagInfo[0].name;
            }
          return tagName;
        },
        getSubclipsOfSelectedAssets(assetID,isLoadMore){
          if(!isLoadMore){
            this.subclipsList = [];
          }
          if(!assetID){
              return;
          }
          let payload = {}
            payload.params = {asset_type:"subclip",master_asset_id:assetID,page:this.page,"metadata":"metadata"}
            this.getSubclipsFromServer(payload).then((data) => {
                this.totalSubclipsPages = data.page_count;
                if(isLoadMore == true){
                    this.subclipsList = this.subclipsList.concat(data.assets);
                }else{
                    this.subclipsList = data.assets;
                }
                this.subclipsList = this.subclipsList.sort((a,b)=>{
                    if (a.markers.start !== b.markers.start) {
                    return a.markers.start - b.markers.start;
                    } else {
                    return a.markers.end - b.markers.end;
                    }
                });
            })
        },
        loadMoreSubclips(e){
        if(this.subclipsList.length){
          if (e.target.offsetHeight + e.target.scrollTop >= e.target.scrollHeight) {
                  if(this.page < this.totalSubclipsPages){
                    this.page = this.page + 1;
                    if ("asset_id" in this.assetDetails){
                      this.getSubclipsOfSelectedAssets(this.assetDetails.asset_id,true);
                    }else{
                      this.getSubclipsOfSelectedAssets(this.assetDetails._id,true);
                    }
                  }
                  
              }
        }
      },
        setAssetInfo(info){
          this.assetDetails = {}
          Object.assign(this.assetDetails, info)
          if(Object.keys(this.assetDetails).includes("custom_metadata")){
            Array.prototype.push.apply(this.assetCustomMetadata, this.assetDetails.custom_metadata)   
          }
          if(Object.keys(info).includes('field_info')){
            this.fieldInfo = info["field_info"];
          }
          this.slugName = `${this.assetDetails.slug_name}`
          if (Object.keys(this.assetDetails).includes("catalog_path")){
             if(this.assetDetails.catalog_path.length > 0){
                this.categoryDetails = this.assetDetails.catalog_path
            }
          }else if (Object.keys(this.assetDetails).includes("parent_path")){
             if(this.assetDetails.parent_path.length > 0){
                this.categoryDetails = this.assetDetails.parent_path
            }
          } 
          if(Array.isArray(this.categoryDetails) && this.categoryDetails.length > 0){
            this.categoryDetails = this.categoryDetails.filter(e => e._id != "0")
          }  
          if (this.context == "catalog" && Object.keys(this.assetDetails).includes("asset_ttl")){
                this.ttlToDelete = this.assetDetails.asset_ttl
          }else if (this.context == "bins" && Object.keys(this.assetDetails).includes("ttl")){
                this.ttlToDelete = this.assetDetails.ttl
          }  
          if (this.context == "catalog" && Object.keys(this.assetDetails).includes("asset_ttk")){
            this.delPermttl = this.assetDetails.asset_ttk
          }else if (this.context == "bins" && Object.keys(this.assetDetails).includes("ttk")){
            this.delPermttl = this.assetDetails.ttk
          }
          if(Object.keys(this.assetDetails).includes('tag_info')){
            this.tagIdNameMapper = this.assetDetails.tag_info;
          }
          if(Object.keys(this.assetDetails).includes('label_info')){
            this.labelInfo = this.assetDetails.label_info;
          }if(Object.keys(this.assetDetails).includes('metadata') &&
            Object.keys(this.assetDetails.metadata).includes('tag_ids') &&
          this.assetDetails.metadata.tag_ids.length > 0){
            this.getTagIds = this.assetDetails.metadata.tag_ids;
          }
          this.description = `${this.getDescription()}`;
          if(this.assetDetails.file_info){
            this.assetInfo.file_info = this.assetDetails.file_info;
          }
          if ("asset_id" in this.assetDetails){
            this.getSubclipsOfSelectedAssets(this.assetDetails.asset_id,false);
          }else{
            this.getSubclipsOfSelectedAssets(this.assetDetails._id,false);
          }
          if('link_info' in info){
            this.assetInfo["link_info"] = info['link_info']
            let parentAssetLinkType = []
            if('link_info' in this.assetInfo && this.assetInfo["link_info"]){
                parentAssetLinkType = this.assetInfo["link_info"]
            }
            parentAssetLinkType.forEach(obj => {
                    // Check if the object has a uuid property
                    if (!('uuid' in obj)) {
                        // If uuid property is missing, add default uuid: 123
                        obj.uuid = Utils.getUUID();
                    }});
            this.labelOflinksList = {};
            let linksInfoFromServer = JSON.parse(JSON.stringify(parentAssetLinkType));
            if(typeof linksInfoFromServer != "undefined" && linksInfoFromServer.length > 0){
              for(let loadC of linksInfoFromServer){
                let validLink = false
                let link_info = this.linksList.find(op=>op.inward_uid == loadC.link_id)
                if(link_info){
                    validLink = true
                    this.labelOflinksList[loadC.uuid] = {"inward_desc":link_info.inward_desc};
                }else{
                    let link_info = this.linksList.find(op=>op.outward_uid == loadC.link_id)
                    if(link_info){
                        validLink = true
                        this.labelOflinksList[loadC.uuid] = {"inward_desc":link_info.outward_desc};
                    }
                }
                if(validLink){
                    this.selectedLinkList.push(loadC)
                }
              }
            }
          }
          if('asset_properties' in this.assetDetails && Object.keys(this.assetDetails['asset_properties']).length > 0){
            let status_info = this.assetDetails['asset_properties']['status_info'];
            if('contents' in status_info){
              this.contentInfo = status_info.contents;
            }
            if('size' in status_info){
              this.catalogOrFolderSize = status_info.size;
            }
            if(this.assetDetails['asset_properties']['state'] == 'COMPLETED'){
              this.jobId = null;
            }else{
              this.jobId = this.assetDetails['asset_properties']['job_id']
            }
          }
          this.isLoaded=true ;
        },
        calculateCatalogOrFolderSize(){
          if(this.jobId){
            return
          }
          this.catalogOrFolderSize = 0;
          this.contentInfo = [];
          this.jobId = null;
          if(this.assetInfo.asset_type && this.assetInfo.asset_type == 'catalog'){
            let payload = {"asset_id": this.assetInfo.asset_id, "job_name": "Catalog Properties", "element_type":"assets"};
            if(this.barcodeInfoFromStartup.enable_department && Utils.getLocalStorageValue('selectedDepartmentsArr') && Utils.getLocalStorageValue('selectedDepartmentsArr').length > 0){
              if(JSON.parse(Utils.getLocalStorageValue('selectedDepartmentsArr').includes('all'))){
                payload['department'] = 'all';
              }else{
                payload['department'] = JSON.parse(Utils.getLocalStorageValue('selectedDepartmentsArr'));
              }
            }
            this.createNewJob(payload).then((data) => {
                if (data.statusCode == 200) {
                  this.jobId = data.job_id;
                } else {
                  this.isJobFailed = true;
                  if('message' in data){
                    this.$toast.error(data.message);
                  }
                }
            });
          }else if(this.assetInfo.file_type && this.assetInfo.file_type == 'folder'){
            let payload = {"folder_id": this.assetInfo._id, "job_name": "Folder Properties", "element_type":"assets"};
            this.createNewJob(payload).then((data) => {
                if (data.statusCode == 200) {
                  this.jobId = data.job_id;
                } else {
                  this.isJobFailed = true;
                  if('message' in data){
                    this.$toast.error(data.message);
                  }
                }
            });
          }
        },
        customMetadataLengthCheck(){
        if(document.getElementsByClassName("custom-metadata-rows").length > 0){
            return true;
          }else{
            return false;
          }
        },
        refreshFileInfoAndShowAsset(fileId){
          let payload = {}
          if (this.assetId && (['catalogs-display','media-pipeline-stage'].includes(Utils.getCookieValue("context")))){
            payload.params = {assetId: this.assetId}
            this.getAssetInfoFromServer(payload).then((data) => {
                this.setAssetInfo(data["asset"])
            })
          }else{
            if(Utils.getCookieValue("context") == 'bins'){
                payload.params = {fileId: fileId, metadata:true}
                this.getFileInfoFromServer(payload).then((data) => {
                    this.setAssetInfo(data["file"])
                })
            }else{
              if(this.assetId){
                payload.params = {assetId: this.assetId}
                this.getAssetInfoFromServer(payload).then((data) => {
                    this.setAssetInfo(data["asset"])
                })
              }
            }
          }
        },
        handlePropertiesNotification(notification){
          notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
          if(notification.message){
            if (this.assetInfo.asset_id == notification.message.asset_id){
              this.refreshFileInfoAndShowAsset(this.assetInfo.file_uid);
            }else if (notification.message_type == NotifierConstants.assetRemovedCreatedNotification){
                this.subclipsList = this.subclipsList.filter((asset)=>asset._id!=notification.message.asset_id)
            }if(notification.message_type == NotifierConstants.assetCreatedNotification){
              if(notification.message.master_asset_id && (notification.message.master_asset_id == this.assetDetails.asset_id || notification.message.master_asset_id == this.assetDetails._id)){
                  if(notification.message.asset_type == 'subclip'){
                    this.subclipsList.unshift(notification.message);
                  }
              }
            }
          }
        },
        handleAssetLinkTypeNotification(notification){
            notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
            if(notification.message){
                let entry_info = notification.message
                if ([NotifierConstants.AssetLinkTypeDeleted].includes(notification.message_type)){
                    let fIndex = this.linksList.findIndex(item=>item._id == entry_info._id);
                    if(fIndex >= 0){
                        this.linksList.splice(fIndex,1)
                    }
                    // Delete from the added row
                    let aIndx = this.selectedLinkList.findIndex(op=>op.link_id == entry_info.inward_uid);
                    if(aIndx>=0){
                        this.selectedLinkList.splice(aIndx, 1)
                    }else{
                        let oIndx = this.selectedLinkList.findIndex(op=>op.link_id == entry_info.outward_uid);
                        if(oIndx>=0){
                            this.selectedLinkList.splice(aIndx, 1)
                        }
                    }
                }else if([NotifierConstants.AssetLinkTypeUpdated].includes(notification.message_type)){
                    let fIndex = this.linksList.findIndex(item=>item._id == entry_info._id);
                    if(fIndex >= 0){
                        this.linksList[fIndex] = entry_info
                    }
                    //Update label of link type
                    let aObj = this.selectedLinkList.find(op=>op.link_id == entry_info.inward_uid);
                    if(aObj){
                        this.$set(this.labelOflinksList[aObj.uuid],"inward_desc", entry_info.inward_desc)
                    }else{
                        let oObj = this.selectedLinkList.find(op=>op.link_id == entry_info.outward_uid);
                        if(oObj){
                            this.$set(this.labelOflinksList[oObj.uuid],"inward_desc", entry_info.outward_desc);
                        }
                    }
                    this.$forceUpdate();
                }else if(notification.message_type == NotifierConstants.AssetLinkTypeCreated){
                    this.linksList.push(entry_info)
                }
            }
        },
        handleAnnotationCommentCreated_properites(notification){
          notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification;
          if(notification.message && notification.message.comment_type == 'annotate'){
                let foundIndex = this.annotationComments.asset_comments.findIndex((el)=>{
                      return el._id == notification.message._id;
                });
                if(foundIndex == -1)
                    this.annotationComments.asset_comments.unshift(notification.message);
          }
        },
        handleCatalogCountSizeUpdatedNotification(notification){
          notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
          if(notification.message){
            //files lock state
            let job_info = notification.message
            if(job_info.job_name == "Lock/Unlock" && job_info.state == 'COMPLETED'){
              if('file_uid' in job_info && job_info.file_uid.length > 0){
                // Iterate over the assetsList
                this.assetInfo.file_info.forEach(file => {
                  // Check if the file_uid exists in array job_info.file_uid
                  if (job_info.file_uid.includes(file.file_uid)) {
                    // Add the 'lock' property to the matched entry
                    this.$set(file, 'lock', job_info.asset_lock);
                  }
                });
              }
            }


            //folder or Catalog contenxt details
            let loadContents = false;
            if(this.jobId != notification.message.job_id || this.getLoggedInUserId != notification.message.user_id){
              return;
            }
            if(this.assetInfo.file_type && this.assetInfo.file_type == 'folder' &&
             'folder_id' in notification.message && notification.message.folder_id == this.assetInfo._id){
              loadContents = true;
            }else if(this.assetInfo.asset_type && this.assetInfo.asset_type == 'catalog' &&
             'asset_id' in notification.message && notification.message.asset_id == this.assetInfo._id){
              loadContents = true;
            }
            if(loadContents){
              let status_info = notification.message.status_info;
              if('contents' in status_info){
                this.contentInfo = status_info.contents;
              }
              if('size' in status_info){
                this.catalogOrFolderSize = status_info.size;
              }
              if(notification.message.state == 'COMPLETED'){
                this.jobId = null;
              }
            }
          }
        },
        getDisplayDataOfUserUsingId(userId){
          return Utils.getDisplayDataOfUser(userId, this.getUsersBasicInfoFromStore);
        },
        handleAnnotationCommentModified_properties(notification){
          notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification;
          if(notification && notification.message){
            let foundIndex = this.annotationComments.asset_comments.findIndex((el)=>{
                  return el._id == notification.message._id;
            });
            if(foundIndex > -1){
              this.$set(this.annotationComments.asset_comments,foundIndex,notification.message)
            }
          }
        },

        
        async getContainerStatus() {
          this.containerStatuses = {};

          try {
            const data = await this.getAltoContainerStatusInProperties({
              fileUID: this.assetInfo.file_uid
            });

            if (!Utils.isAcceptedStatusCode(data?.statusCode)) {
              // Handles HTTP errors and network failures returning {}
              this.$toast.error(
                data?.message || this.$t("Error while fetching container status")
              );
              return;
            }

            const containers = data?.alto?.container_archive_path || [];

            containers.forEach(container => {
              this.$set(
                this.containerStatuses,
                container.container_id,
                container.is_accessible
              );
            });

          } catch (error) {
            console.error("Error fetching container status:", error);
            this.$toast.error(this.$t("Error while fetching container status"));
          }
        },


        registerforWebsocketNotifications(){
          this.addWSEventListener({eventname:["JOB_STATUS_UPDATE"], callback:this.handleCatalogCountSizeUpdatedNotification,parent:"BasicProperties"})
          this.addWSEventListener({
            eventname:[NotifierConstants.assetModifiedNotification,NotifierConstants.assetCreatedNotification,NotifierConstants.assetRemovedCreatedNotification, NotifierConstants.fileModifiedNotification],
            callback:this.handlePropertiesNotification,
            parent: "BasicProperties"})
          this.addWSEventListener({eventname:[NotifierConstants.AssetLinkTypeCreated, NotifierConstants.AssetLinkTypeUpdated, NotifierConstants.AssetLinkTypeDeleted],callback:this.handleAssetLinkTypeNotification,parent: "BasicProperties"});
          this.addWSEventListener({eventname:NotifierConstants.assetCommentCreated, callback:this.handleAnnotationCommentCreated_properites,parent:"BasicProperties"});
          this.addWSEventListener({eventname:NotifierConstants.assetCommentModified, callback:this.handleAnnotationCommentModified_properties,parent:"BasicProperties"});  
        },
        unRegisterforWebsocketNotifications(){
          this.removeWSEventListener({eventname:["JOB_STATUS_UPDATE"], callback:this.handleCatalogCountSizeUpdatedNotification,parent:"BasicProperties"})
          this.removeWSEventListener({
            eventname:[NotifierConstants.assetModifiedNotification,NotifierConstants.assetCreatedNotification,NotifierConstants.assetRemovedCreatedNotification, NotifierConstants.fileModifiedNotification],
            callback:this.handlePropertiesNotification,
            parent: "BasicProperties"})
          this.removeWSEventListener({eventname:[NotifierConstants.AssetLinkTypeCreated, NotifierConstants.AssetLinkTypeUpdated, NotifierConstants.AssetLinkTypeDeleted],callback:this.handleAssetLinkTypeNotification,parent: "BasicProperties"});
          this.removeWSEventListener({eventname:NotifierConstants.assetCommentCreated, callback:this.handleAnnotationCommentCreated_properites,parent:"BasicProperties"});
          this.removeWSEventListener({eventname:NotifierConstants.assetCommentModified, callback:this.handleAnnotationCommentModified_properties,parent:"BasicProperties"});
        },
    ...mapActions("jobs", ["createNewJob"]),
    ...mapActions("customMetadata",["getAllCustomMetadataFromServer"]),
    ...mapActions("files", ["getFileInfoFromServer"]),
    ...mapActions("tags", ["getTagInfoFromServer"]),
    ...mapGetters("tags", ["getTagsFromInCache"]),
    ...mapActions("assets", ["getAssetInfoFromServer","getSubclipsFromServer", "getAssetLinkTypesFromServer","getAssetsAnnotationWithComments", "getAltoContainerStatusInProperties"]),
    ...mapActions("assets",["getCategoryTreefromId"]),
    ...mapGetters("startUpData",["getStartUpDataFromInCache"]),
    ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
    ...mapMutations("registry",["updatePropertiesMetadataPlugins"]),
    },
    beforeDestroy(){
      this.unRegisterforWebsocketNotifications()
    },
    async created(){
      let data = await this.getAssetLinkTypesFromServer();
      if (Utils.isAcceptedStatusCode(data.statusCode)){
          this.linksList = data.link_types;
      }
      let assetOrFileId = ""
      if(this.fileInfo != undefined){
        this.assetInfo = this.fileInfo;
        if ("asset_id" in this.fileInfo){
          this.assetId = this.fileInfo.asset_id
        }else{
          this.assetId = this.fileInfo._id;
        }
        if (this.context == "catalog"){
          this.ttlToDelete = this.fileInfo.asset_ttl;
          this.delPermttl = this.fileInfo.asset_ttk;
        }else if (this.context == "bins"){
          this.ttlToDelete = this.fileInfo.ttl;
          this.delPermttl = this.fileInfo.ttk;
        }
        assetOrFileId = this.assetId;
      }
      if('file_uid' in this.assetInfo && this.assetInfo.file_uid != undefined){
        assetOrFileId = this.assetInfo.file_uid;
      }
      this.refreshFileInfoAndShowAsset(assetOrFileId)
      if(Object.keys(this.getStartUpDataFromInCache()).includes("custom_metadatas")){
          this.customMetadataList = this.getStartUpDataFromInCache()["custom_metadatas"];
      }
      this.registerforWebsocketNotifications();

      for(let i = 0; i < this.getPropertiesMetadataPlugins.length; i++){
          if(!Object.prototype.hasOwnProperty.call(this.getPropertiesMetadataPlugins[i],'component')){
             console.log(`this.getPropertiesMetadataPlugins[i]`,this.getPropertiesMetadataPlugins[i],'[this.getPropertiesMetadataPlugins[i].pluginBundle.js]',[this.getPropertiesMetadataPlugins[i].pluginBundle.js]);
             let compInfo = await  Utils.loadPluginBundles([this.getPropertiesMetadataPlugins[i].pluginBundle.js],this.getPropertiesMetadataPlugins[i].componentLoadedEventName);
             console.log("............compInfo",compInfo);
             if(compInfo && Array.isArray(compInfo) && compInfo.length){
                if('register' in this.getPropertiesMetadataPlugins[i]){
                  this.getPropertiesMetadataPlugins[i].register();
                }
                Utils.loadCssBundle(this.getPropertiesMetadataPlugins[i].pluginBundle.css);
                this.updatePropertiesMetadataPlugins({id:this.getPropertiesMetadataPlugins[i].id,data:{component:compInfo[0].components}});
             }
          }
      }

    },
}
</script>


<style lang="scss" scoped>
$table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;
$icon-hover:#2c3339;

ul{
    list-style-type: none;
    padding: 0px;
    margin-inline-start:10px;
    li{
        display:inline-flex;
        width: 100%;
        padding:7px;
        .key-style{
            color:$dull-text-color;
            width:17%;
            text-align: end;
        }
        .value-style{
            color: #b6b6b6;
            width: 80%;
            text-align: start;
            margin-inline-start: 11px;
            word-break: break-all;
        }
    }
}
.assets-details-in-metadata-manager{
  height:90%;
  overflow:auto
}

.view-tags {
  font-size: 12px !important;
  height: 24px !important;
  display: inline-flex !important;
  margin: 2px !important;
  border: $border-color !important;
  border-radius: 15px !important;
  min-width: 50px !important;
  padding: 0px !important;
  text-align: center;
  width: auto !important;
  padding-inline-start: 12px !important;
  justify-content: center;
  padding-top: 1px !important;
  span {
    padding: 0px 8px !important;
    margin-inline-start: 0px !important;
    font-size: 12px !important;
    border-radius: 15px !important;
    position: relative !important;
    top: 1px !important;
  }
}

.subclips-section{
  ul{
    width:93%;
    li{
      display: inline-block;
      width: 100%;
      padding: 7px;
      border: $border-color;
      border-radius: 4px;
      margin: 4px 8px;
      width: 96%;
      position: relative;
      background:$primary-background;
    }
  }
}

.transcript-section{
    display: inline-block;
    width: 100%;
    padding: 7px;
    border: $border-color;
    border-radius: 4px;
    margin: 4px 8px;
    width: 96%;
    position: relative;
    background:$primary-background;
}

.active-subclip-preview{
  border: 2px solid $active-blue !important;
}

.change-the-text-color{
    text-transform: uppercase;
    height: 22px;
    width: fit-content;
    border-radius: 10px;
    padding: 3px 9px;
    font-size: 10px;
    letter-spacing: 0.5px;
  }

  .value-style{
    display: flex;
    flex-wrap: wrap
  }

  .wrap-file-info{
    border: 1px solid #384445;
    border-radius: 10px;
    background: #202729 !important;
    margin: 10px 5px;
    padding: 5px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    margin-top: 0px;
  }

  .transcript-play {
    display: flex;
    align-items: flex-start;
    gap: 6px;
    position: relative;
    // inset-inline-start :-20px;
    .transcript-play-pause{
        //  visibility: hidden;
        svg{
          fill:#5e5e5e !important;
        }
         position: relative;
        //  inset-inline-start:5px;
         svg {
            fill : #5e5e5e !important;
         }
     }
  }
  .transcript-list:hover .transcript-play-pause{
    //  visibility: visible;
    svg{
      fill:#eee !important;
    }
     cursor: pointer;
  }

  .transcript-and-timescode {
    display: flex;
    align-items: center;
 }

  .icon-background-on-hover:hover{
    background: #d1d2d31a;
    cursor: pointer;
  }

.icon-background-on-hover{
    padding: 6px;
    height: 28px;
    width: 28px;
    border-radius: 4px;
    cursor: pointer;
  }


.user-name-or-image {
  height: 30px;
  width: 30px;
  border: $border-color;
  border-radius: 10px;
  text-align: center;
  line-height: 28px;
  text-transform: uppercase;
  margin-top: 3px;
  margin-inline-start: 5px;
}


  .common-media-in-out-display{
          font-size: 14px;
          background: rgb(52, 52, 52);
          padding: 4px 5px; 
          justify-content: start; 
          display: flex; 
          border-radius: 3px;
          color: rgb(238, 238, 238) !important;
          gap:3px;
    }

  .storage-type-icon{
    margin-inline-end:4px;
    margin-top:2px;
  }
  .comm-screen-profile-fields:hover{
        .editIconClass{
            visibility: visible;
            margin-inline-start: 8px;
        }
    }
    .comm-table-row:hover .delete-btn {
        visibility: visible;
        position: relative;
        // inset-inline-start:18px;
    }

    .thumbnail-view-ul {
        list-style-type: none;
        display: grid;
        flex-wrap: wrap;
        padding: 0px;
        margin-top: 0px;
        width: 100%;
        padding-inline-start: 20px;
        justify-content: start;
        // overflow: auto;
        li {
            display: inline-block;
            margin-inline-end: 10px;
            width: 100%;
            padding-inline-start: 5px;
            margin-top: 5px;
            height: 128px;
            .asset-thumbnail {
                height: 90px;
                width: 160px;
                border-radius: 7px;
                margin-top: 8px;
                border:$border-color;
                position:relative;
                img {
                    max-width: 100%;
                    max-height: 100%;
                    border-radius: 7px;
                    object-fit: contain;
                    border-radius: 7px;
                }
            }
            .thumbnail-data {
                text-align: center !important;
            }
        }
    }
    .folder-view-ul {
        padding-bottom: 10px;
        margin-bottom: 10px;
        .folder-view-li {
            display: inline-flex !important;
            height: 52px !important;
            border: $border-color;
            border-radius: 6px;
            position: relative;
            .folder-view {
                font-size: 30px;
            }
            .catalogs-data {
                margin-top: 10px;
                margin-inline-start: 7px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                text-align: start;
                white-space: nowrap;
                max-width: 360px !important;
            }
        }
    }

    .svg-icons-display{
        height: 20px;
        width: 20px;
        opacity:0.8;
        inset-inline-end: 5px;
    }
    .icons-wrapper{
      margin-inline-start: 3px;
      z-index: 1;
      background: #525252;
      border: 1px solid #262626;
      width: 48px;
      height: 38px;
      padding: 7px;
      top: 0px;
      border-radius: 4px;
      visibility: hidden;
      color: #fff;
    }

    .folder-view-li:hover{
      position:relative;
      .icons-wrapper{
        visibility: visible;
      }
    }

  .display-label{
    height: 26px;
    width: fit-content;
    border: 1px solid #F49D1A;
    border-radius: 15px;
    padding: 3px 9px;
    color: #F49D1A;
    font-size: 10px;
    letter-spacing: 0.5px;
    padding-top: 4px !important;
  }
  .folder_size{
    cursor: pointer;
    color:#9a9620 !important;
  }
  .folder_size:hover {
    text-decoration-line: underline;
  }
</style>